var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheerup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17H4.90909V8H2V17ZM18 8.75C18 7.925 17.3455 7.25 16.5455 7.25H11.9564L12.6473 3.8225L12.6691 3.5825C12.6691 3.275 12.5455 2.99 12.3491 2.7875L11.5782 2L6.79273 6.9425C6.52364 7.2125 6.36364 7.5875 6.36364 8V15.5C6.36364 16.325 7.01818 17 7.81818 17H14.3636C14.9673 17 15.4836 16.625 15.7018 16.085L17.8982 10.7975C17.9636 10.625 18 10.445 18 10.25V8.75Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheerup);
export default __webpack_public_path__ + "static/media/icon_cheerup.415d79f4f2f8eb252a8190a52ba2a0c7.svg";
export { ForwardRef as ReactComponent };